const normalizeId = (value) => value == null ? '' : String(value).trim();
const exactOrderId = (id) => `^${id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$`;

// Selection persists across pages and searches. Fetch by the selection itself,
// never by the currently visible table rows or their cached line items.
export async function loadSelectedOrderLabels(selectedIds, fetchOrders) {
  const ids = [...new Set(selectedIds.map(normalizeId).filter(Boolean))];
  if (!ids.length) throw new Error('Select at least one order to print.');
  const details = new Map();
  const summaries = new Map();
  const batchSize = 20;
  for (let offset = 0; offset < ids.length; offset += batchSize) {
    const batch = ids.slice(offset, offset + batchSize);
    // The existing API treats orderId as a regex. Anchor and escape it so a
    // short ID cannot accidentally fetch another order with the same prefix.
    const response = await fetchOrders({ orderId: batch.map(exactOrderId), page: 1, limit: batchSize });
    const payload = response?.data;
    if (!Array.isArray(payload?.orders)) {
      throw new Error('Could not load all selected orders. No labels have been printed. Please try again.');
    }
    const requested = new Set(batch);
    for (const item of payload.orders) {
      const id = normalizeId(item.BackerID);
      if (!requested.has(id)) continue;
      if (!details.has(id)) details.set(id, []);
      details.get(id).push(item);
    }
    for (const item of payload.uniqueOrders || []) {
      const id = normalizeId(item.BackerID);
      if (requested.has(id)) summaries.set(id, item);
    }
  }
  const missing = ids.filter(id => !details.get(id)?.length);
  if (missing.length) {
    throw new Error(`Could not load ${missing.length} of ${ids.length} selected orders (${missing.slice(0, 10).join(', ')}${missing.length > 10 ? ', …' : ''}). No labels have been printed. Check access and try again.`);
  }
  return ids.map(id => ({ order: summaries.get(id) || details.get(id)[0], items: details.get(id) }));
}
